module.exports = __webpack_public_path__ + "static/media/fun5.ce7ab383.png";